import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { RobotProvider } from "@/context/RobotContext";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";

function Gate({ children }) {
  const { user, ready } = useAuth();
  if (!ready)
    return (
      <div className="min-h-screen grid place-items-center bg-[#0A0B0E] text-[#FF5A00] font-mono">
        <span>booting mechalog<span className="cursor-blink">█</span></span>
      </div>
    );
  return user ? children : <Navigate to="/login" replace />;
}

function LoginRoute() {
  const { user, ready } = useAuth();
  if (!ready) return null;
  return user ? <Navigate to="/" replace /> : <Login />;
}

function App() {
  useEffect(() => {
    document.title = "MechaLog — Robot Control";
  }, []);
  return (
    <div className="App">
      <AuthProvider>
        <RobotProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<LoginRoute />} />
              <Route
                path="/"
                element={
                  <Gate>
                    <Dashboard />
                  </Gate>
                }
              />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" theme="dark" />
        </RobotProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
